module.exports = {
	"version": "1.2311.8",
	"manifest": {
		"adminLoginButton": "1.2224.7",
		"animations": "1.2224.7",
		"audioCommon": "1.2311.5",
		"audioPlayer": "1.2224.7",
		"backToTopButton": "1.2224.7",
		"backgroundCommon": "1.2311.5",
		"balata": "1.2271.8",
		"bgImageStrip": "1.2224.7",
		"boxSlideShowSlide": "1.2224.7",
		"buttonCommon": "1.2224.7",
		"checkbox": "1.2311.5",
		"clipArt": "1.2224.7",
		"column": "1.2224.7",
		"comboBoxInput": "1.2311.5",
		"compDesignUtils": "1.2293.8",
		"compUtils": "1.2311.5",
		"components": "1.2311.5",
		"componentsPreviewLayer": "1.2293.8",
		"contactForm": "1.2293.13",
		"container": "1.2224.7",
		"containerCommon": "1.2271.8",
		"core": "1.2311.8",
		"coreUtils": "1.2293.11",
		"dataFixer": "1.2311.5",
		"datePicker": "1.2293.11",
		"dateUtils": "1.2224.7",
		"deadComponent": "1.2224.7",
		"displayer": "1.2311.5",
		"disqusComments": "1.2293.15",
		"documentMedia": "1.2224.7",
		"documentServices": "1.2311.5",
		"documentServicesSchemas": "1.2311.5",
		"dropDownMenu": "1.2224.7",
		"editingRendererPlugins": "1.2224.7",
		"exitMobileModeButton": "1.2224.7",
		"facebookComments": "1.2224.7",
		"facebookLike": "1.2224.7",
		"facebookLikeBox": "1.2224.7",
		"facebookShare": "1.2224.7",
		"fileUploader": "1.2293.11",
		"flashComponent": "1.2224.7",
		"flickrBadgeWidget": "1.2224.7",
		"fonts": "1.2271.8",
		"fontsPrefetch": "1.2224.7",
		"footerContainer": "1.2224.7",
		"formCommon": "1.2293.8",
		"galleriesCommon": "1.2224.7",
		"googleMap": "1.2224.7",
		"groupContainer": "1.2224.7",
		"headerContainer": "1.2224.7",
		"hoverBox": "1.2224.7",
		"htmlComponent": "1.2224.7",
		"image": "1.2311.5",
		"imageButton": "1.2224.7",
		"imageClientApi": "1.2224.7",
		"imageCommon": "1.2311.5",
		"imageZoom": "1.2254.5",
		"imageZoomDisplayer": "1.2224.7",
		"infoTip": "1.2224.7",
		"internalMarkings": "1.2240.7",
		"itunesButton": "1.2271.8",
		"layout": "1.2311.5",
		"linkBar": "1.2224.7",
		"loggingUtils": "1.2311.8",
		"loginButton": "1.2293.8",
		"matrixGallery": "1.2224.7",
		"mediaCommon": "1.2293.8",
		"mediaContainerFactory": "1.2293.8",
		"mediaControls": "1.2311.5",
		"mediaPlayer": "1.2293.8",
		"mediaZoom": "1.2293.8",
		"menuButton": "1.2224.7",
		"messageView": "1.2224.7",
		"mobileActionsMenu": "1.2271.8",
		"multilingual": "1.2293.8",
		"page": "1.2254.5",
		"pageGroup": "1.2293.8",
		"paginatedGridGallery": "1.2311.5",
		"paypalButton": "1.2224.7",
		"pinItPinWidget": "1.2224.7",
		"pinterestFollow": "1.2224.7",
		"pinterestPinIt": "1.2271.8",
		"popupCloseTextButton": "1.2224.7",
		"popupContainer": "1.2224.7",
		"previewExtensionsCore": "1.2224.7",
		"qaAutomation": "1.2293.8",
		"quickActionBar": "1.2293.8",
		"quickActionBarItem": "1.2224.7",
		"radioButton": "1.2293.8",
		"radioGroup": "1.2311.5",
		"render": "1.2293.14",
		"rssButton": "1.2224.7",
		"santaPreview": "1.2311.5",
		"santaProps": "1.2311.5",
		"screenWidthContainer": "1.2224.7",
		"server": "1.2224.7",
		"singleAudioPlayer": "1.2311.5",
		"siteBackground": "1.2293.8",
		"siteButton": "1.2224.7",
		"siteUtils": "1.2311.5",
		"skinExports": "1.2240.5",
		"skins": "1.2311.5",
		"skypeCallButton": "1.2224.7",
		"slideShowGallery": "1.2311.5",
		"sliderGallery": "1.2311.5",
		"socialCommon": "1.2224.7",
		"soundCloudWidget": "1.2224.7",
		"spotifyFollow": "1.2224.7",
		"spotifyPlayer": "1.2224.7",
		"stripColumnsContainer": "1.2271.8",
		"stripContainer": "1.2224.7",
		"stripSlideShow": "1.2293.8",
		"stripSlideShowSlide": "1.2224.7",
		"subscribeForm": "1.2293.8",
		"svgCommon": "1.2240.5",
		"svgShape": "1.2271.8",
		"testUtils": "1.2311.5",
		"textArea": "1.2311.5",
		"textCommon": "1.2311.5",
		"textInput": "1.2293.8",
		"tinyMenu": "1.2240.5",
		"tpa": "1.2311.5",
		"tpaGalleries": "1.2311.5",
		"translationsUtils": "1.2224.7",
		"tweenEngine": "1.2224.7",
		"twitterFeed": "1.2224.7",
		"utils": "1.2311.5",
		"vKShareButton": "1.2224.7",
		"verticalAnchorsMenu": "1.2224.7",
		"verticalMenu": "1.2224.7",
		"video": "1.2224.7",
		"wGooglePlusOne": "1.2254.5",
		"wPhoto": "1.2224.7",
		"wRichText": "1.2224.7",
		"wTwitterFollow": "1.2224.7",
		"wTwitterTweet": "1.2224.7",
		"warmup": "1.2311.5",
		"widgets": "1.2311.5",
		"wixCode": "1.2293.8",
		"wixCodeInit": "1.2293.8",
		"wixCodeSeo": "1.2293.8",
		"wixSites": "1.2271.8",
		"wixSkinOnly": "1.2224.7",
		"wixUrlParser": "1.2293.8",
		"wixappsBuilder": "1.2271.8",
		"wixappsClassics": "1.2293.15",
		"wixappsCore": "1.2311.5",
		"youTubeSubscribeButton": "1.2224.7",
		"zoomedImage": "1.2224.7"
	},
	"versions": {
		"mobx": "3.1.0",
		"mobxReact": "3.5.8",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"disqusComments",
		"documentMedia",
		"documentServices",
		"documentServicesSchemas",
		"dropDownMenu",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"imageZoomDisplayer",
		"infoTip",
		"internalMarkings",
		"itunesButton",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"mediaZoom",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"page",
		"pageGroup",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"quickActionBarItem",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaPreview",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"video",
		"wGooglePlusOne",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 26
// module chunks = 0